import PosthogService from '~/services/posthog/PosthogService';

/**
 * Fires when the user clicks "No Thanks" on the Invite Recommendation popup
 * Event: dental_portal:invite_recommendation:no_thanks_clicked
 */
export function fireInviteRecommendationNoThanksClicked(): void {
  PosthogService.getInstance().track('dental_portal:invite_recommendation:no_thanks_clicked');
}
